<template>
  <div>
    <NuxtPage />
  </div>
</template>

<script setup lang="ts">
// Minimal layout with no components, no CSS, no API calls
// Used for pages that need to redirect immediately
</script>

<style scoped>
/* Minimal styles only */
body {
  margin: 0;
  padding: 0;
}
</style>
